define.alias("shared/components/shared/profile-categorization/modal", "calendar/components/shared/profile-categorization/modal");